export const getEmployeeCount = (state) =>
    state.employee.employees.maxCount;